var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, FlexItem } from '@bfa/common-ui';
import React from 'react';
import { AnalyticsLink } from '../../../../../../components/Analytics';
import { REFRESHMENTS_URLS } from '../../../../../../constants';
import { SUBSCRIBED_LANDING_UPSELL_SECTION_EVENTS as EVENTS } from '../../../../../../utils/analytics/events';
import UpsellCategoryProductModal from '../UpsellCategoryProductModal';
import { Image, ImageFlex, NameFlex, StrikethroughPrice, StyledFlexItem, StyleText, WrapperFlexItem, } from './UpsellCategoryProduct.styled';
import UpsellCategoryProductCTA from './UpsellCategoryProductCTA';
import useCategoryProduct from './useCategoryProduct';
var UpsellCategoryProduct = function (_a) {
    var product = _a.product, primaryCtaText = _a.primaryCtaText, secondaryCtaText = _a.secondaryCtaText, oneOffCtaText = _a.oneOffCtaText, oneOffAddedCtaText = _a.oneOffAddedCtaText, _b = _a.added, added = _b === void 0 ? false : _b, productModalContent = _a.productModalContent;
    var _c = useCategoryProduct(product), adding = _c.adding, isOnlyOneOff = _c.isOnlyOneOff, formattedPrice = _c.formattedPrice, formattedOneOffPrice = _c.formattedOneOffPrice, formattedRegularPrice = _c.formattedRegularPrice, onProductCTAClick = _c.onProductCTAClick, showModal = _c.showModal, hideModal = _c.hideModal;
    var showStrikethroughPrice = formattedRegularPrice !==
        (isOnlyOneOff ? formattedOneOffPrice : formattedPrice);
    var ctaText = isOnlyOneOff
        ? "".concat(oneOffCtaText, " - ").concat(formattedOneOffPrice)
        : "".concat(primaryCtaText, " - ").concat(formattedPrice);
    var addedCtaText = "".concat(isOnlyOneOff ? oneOffAddedCtaText : secondaryCtaText);
    var dataTestId = isOnlyOneOff
        ? 'upsell-section-oneoff-product'
        : 'upsell-section-subscribe-product';
    return (React.createElement(WrapperFlexItem, { mb: ['0', '3rem'], "data-testid": dataTestId },
        React.createElement(AnalyticsLink, { href: "".concat(REFRESHMENTS_URLS.PDP, "/").concat(product.id), eventData: __assign(__assign({}, EVENTS.CLICK_ON_PRODUCT_CARD), { properties: { productId: product.id } }), passHref: true },
            React.createElement(Box, { as: "a", maxWidth: "18rem" },
                React.createElement(ImageFlex, { alignItems: "center" },
                    React.createElement(Box, { width: "100%", border: added || adding
                            ? "0.3rem solid ".concat(product.addedBorderColor)
                            : '', backgroundColor: added || adding ? product.addedBorderColor : '', borderRadius: "1.3rem" }, product.coloredBackgroundImage && (React.createElement(Image, { images: [
                            {
                                src: product.coloredBackgroundImage.src,
                                alt: product.coloredBackgroundImage.alt,
                                width: 3,
                                height: 4,
                            },
                        ], layout: "fill" })))),
                React.createElement(NameFlex, { alignItems: "center", flexDirection: "column" },
                    React.createElement(FlexItem, null,
                        React.createElement(StyleText, { textAlign: "center", width: "100%", bold: true }, product.name)),
                    React.createElement(StyledFlexItem, null, showStrikethroughPrice && (React.createElement(StrikethroughPrice, { textAlign: "center", color: "grayMedium", margin: "0.5rem 0 1rem" }, formattedRegularPrice)))),
                React.createElement(UpsellCategoryProductCTA, { ctaText: ctaText, addedCtaText: addedCtaText, onClick: onProductCTAClick, added: added || adding }))),
        React.createElement(UpsellCategoryProductModal, { showModal: showModal, hideModal: hideModal, product: product, productModalContent: productModalContent })));
};
export default UpsellCategoryProduct;
